import ResetOrientation from "./ResetOrientation.js";
import RotateLeft from "./RotateCounterClockwise.js";
import RotateRight from "./RotateClockwise.js";
import Satellite from "./Satellite.js";
import TiltDown from "./TiltUp.js";
import TiltUp from "./TiltDown.js";
import Clustering from "./Clustering.js";
export default {
  install(molten) {
    molten.addPlugin('Action', Satellite);
    molten.addPlugin('Action', RotateRight);
    molten.addPlugin('Action', RotateLeft);
    molten.addPlugin('Action', TiltDown);
    molten.addPlugin('Action', TiltUp);
    molten.addPlugin('Action', ResetOrientation);
    molten.addPlugin('Action', Clustering);
  }
};